import React from "react";
import Section1 from "../components/Allproducts/Section1";
import data from '../json/Allproducts/Vedas1.json'
import Section2 from "../components/Allproducts/Section2";
import Section4 from "../components/Allproducts/Section4";
import SEO from "../components/SEO";

const vedasSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "VEDAS",
  "brand": {
    "@type": "Brand",
    "name": "Transforma Pvt Ltd"
  },
  "logo": "https://www.transforma.in/images/transformalogo.svg",
  "description": "VEDAS (Versatile Editor Designed for Accuracy and Speed) is an advanced web-based copy editing platform combining NLP, ML, and XML output for automated manuscript structuring, styling, and reference validation.",
  "offers": {
    "@type": "Offer",
    "priceCurrency": "USD"
  }
};

const Vedas = () => {
  return (
    <>
    <SEO 
        title="VEDAS | Advanced AI-Driven Copy Editing & XML Integration Platform"
        description="Discover VEDAS—a web-based copy editing solution using NLP and ML. Automate manuscript structuring, style applications (APA, AMA, Chicago), DOI/ORCID validation, and XML output generation."
        keywords="VEDAS editor, AI copy editing platform, automated manuscript styling, reference validation tool, DOI ORCID verification, XML output integration, NLP machine learning publishing, digital publishing software, web-based editor"
        canonical="https://www.transforma.in/products/vedas" 
        schema={vedasSchema}
      />
    <div className="w-full flex flex-col items-center ruler">

      <Section1 data={data}/>
      <Section2 data={data.Section3}/>
      <Section4 data={data.Section4}/>
    </div>
    </>
  );
};

export default Vedas;
